import { z } from 'zod'

const booleanStringSchema = z.string().transform((value) => value === 'true' || value === '')

export const queryParametersSchema = z.looseObject({
  full3d: booleanStringSchema.optional(),
  noScrolllock: booleanStringSchema.optional(),
  view: booleanStringSchema.optional(),
  preview: booleanStringSchema.optional(),
  version: z.string().min(1).optional(),
  random_code: z.string().min(1).optional(),
})

export const guidSchema = z
  .string()
  .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)
